import classes from "./SideBar.module.css";
import React, { useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import MenuIcon from '@mui/icons-material/Menu';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import data from '../../Data.json';
import { useDispatch, useSelector } from "react-redux";
import AuthContext from "../authContext";
import axios from "axios";
import { changeCurrency, changeLanguage, editSearchData } from "../../redux/productSlice";
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';




export default function SideBar({ toggle, isOpen }) {
  
  const language = useSelector((state) => state.products.selectedLanguage[0].Language);
  const currency = useSelector((state) => state.products.selectedCurrency[0].currency);
  const user = useSelector((state) => state.products.userInfo);
  const [catopen, setcatisopen] = useState(false);
  const [langopen, setLangisopen] = useState(false);
  const [currenopen, setcurrenisopen] = useState(false);
  const location = useLocation();
  const [parents, setParents] = useState([]);
  const [subparents, setSubparents] = useState([]);
  const [childrens, setChildrens] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const authCtx = useContext(AuthContext);
  const [catChemin, setCatChemin] = useState("");

  
  const getToken = () => {
    return localStorage.getItem("token");
  };

  const token = getToken();

  React.useEffect(() => {
    if (Array.isArray(authCtx.categories)) {
      // Extract the array of categories from the data property
      const categories = authCtx.categories;

      // Categorize categories based on their niveau
      categories.forEach((category) => {
        const niveau = category.niveau;

        if (niveau === 1) {
          setParents((prevParent) => [...prevParent, category]);
        } else if (niveau === 2) {
          setSubparents((prevSubparent) => [...prevSubparent, category]);
        } else if (niveau === 3) {
          setChildrens((prevChild) => [...prevChild, category]);
        }
      });
    } else {
      // console.error(
      //   "Data property does not contain an array of categories:",
      //   authCtx.categories
      // );
    }
  }, [authCtx.categories]);


  const mapSubparentsToParents = () => {
    return parents.map((parent) => {
      const subparentsWithChildren = subparents.map((subparent) => {
        const childrenForSubparent = childrens.filter(
          (child) => child.b_usr_articletheme_id === subparent.id
        );
        return { ...subparent, children: childrenForSubparent };
      });

      const children = subparentsWithChildren.filter(
        (subparent) => subparent.b_usr_articletheme_id === parent.id
      );

      return { ...parent, children };
    });
  };

  // Map subparents and children to parents
  const mappedParents = mapSubparentsToParents();
  
function TreeNode({ data, level, fetchArticles }) {
  const [isExpanded, setIsExpanded] = React.useState(
    localStorage.getItem(`isExpanded_${data.id}`) === 'true' // Retrieve isExpanded from localStorage
  );

  useEffect(() => {
    localStorage.setItem(`isExpanded_${data.id}`, isExpanded); // Save isExpanded to localStorage
  }, [data.id, isExpanded]);

  const handleChildClick = async (id, event) => {
    event.stopPropagation();
    // console.log("Clicked on child with ID:", id);
    const clickedCategory = authCtx.categories.find(
      (category) => category.id === id
    );

    if (clickedCategory) {
      // Create the new search data array
      const newCategoryData = { category: id };

      localStorage.setItem("category", id);
      // Dispatch the action to edit the search data
      dispatch(editSearchData(newCategoryData));
      setIsExpanded(!isExpanded);
      // Fetch articles with the new category ID
      navigate('/books')
      if (window.location.pathname === '/books') {
        window.location.reload();
      }
      toggle()
      try {
        const storedCategory = localStorage.getItem("category");
        // Fetch category path data from the backend API
        const response = await axios.get(
          `${process.env.REACT_APP_TESTING_API}/categories/${storedCategory}`
        ); // Adjust the URL as per your backend API
        const categoryPath = response.data.data.chemin; // Assuming the response contains the category path

        // Update the state with the category path
        setCatChemin(categoryPath);
        // console.log(categoryPath);
      } catch (error) {
        // console.error("Error fetching category path:", error);
        // Handle error appropriately
      }
    }
  };

  const toggleNode = () => {
    if (data.children) {
      setIsExpanded(!isExpanded);
    }
  };

  let fontWeight;
  let fontSize;
  if (level === 0) {
    fontWeight = "600"; // Parent node
    fontSize = "calc(0.7rem + 0.4vw)";
  } else if (level === 1) {
    fontWeight = "600"; // Subparent node
    fontSize = "calc(0.6rem + 0.4vw)";
  } else {
    fontWeight = "600"; // Child node
    fontSize = "calc(0.5rem + 0.3vw)";
  }

  const storedCategory = localStorage.getItem("category");
    
  
  return (
    <div
      style={{
        paddingLeft: level === 0 ? "0" : `${level === 1 ? "3em" : "1.5em"}`,
        margin: "0.5em 0",
      }}
    >
      <div
        style={{
          color: '#fff',
          marginLeft:'1.4em',
          fontSize:
            level === 0 ? "calc(0.8rem + 0.3vw)" : "calc(0.7rem + 0.3vw)",
            display:'flex'
        }}
      >
        {level !== 2 && <KeyboardArrowRightOutlinedIcon  style={{ transform: isExpanded ? 'rotate(90deg)' : 'none' }} onClick={toggleNode} className={classes.listBox} />}
        <p
          style={{ 
            margin: "0", 
            width:'100%',
            display: "flex", 
            cursor: "pointer",
            background: storedCategory && storedCategory === data.id.toString() ? 'var(--secondary-color)' : 'transparent'
          }}
          onClick={(event) => handleChildClick(data.id, event)}
        >
          {data._nom}
        </p>
      </div>
      {isExpanded && data.children && (
        <>
          {data.children.map((child, index) => (
            <p key={index}>
              <TreeNode
                data={child}
                level={level + 1}
                fetchArticles={fetchArticles}
              />
            </p>
          ))}
        </>
      )}
    </div>
  );
}
  const list = (anchor) => ( 
    <>
    <button style={{position:'absolute',top:'2em', right:'2em', color:'#fff'}}>
      <HighlightOffIcon style={{width:'45px', height:'45px'}} onClick={toggle}/>
    </button>
    <button style={{position:'absolute',justifyContent:'start', background:'var(--accent-color)', top:'4.5em', padding:'.5em 1.5em .5em 2em', borderRadius:'0 4em 0 0', color:'#fff'}}>
    <MenuIcon />
  </button>
    <Box
      sx={{ height: "fit-content !important" }}
      role="presentation"
      // onClick={toggle}
      // onKeyDown={toggle}
      className={classes.container}
    >
      
      <List>

      <Divider
          color="white"
          width="100%"
        />

        <Link  to='/' style={{textDecoration: 'none', color:'white'}} onClick={toggle}>
        <ListItem disablePadding>
          <ListItemButton>
            <ListItemText className={classes.text}>{language === 'eng' ? "HOME" : "ACCUEIL"} </ListItemText>
          </ListItemButton>
        </ListItem>
        </Link>


        <Divider
          color="white"
          width="100%"
        />


        {/* <Link  to='/books' style={{textDecoration: 'none', color:'white'}} onClick={toggle}> */}


        <Link  to='/books' style={{textDecoration: 'none', color:'white'}} onClick={toggle}>
        <ListItem disablePadding>
          <ListItemButton>
            <ListItemText className={classes.text}>{language === 'eng' ? "BOOKS" : "LIVRES"} </ListItemText>
          </ListItemButton>
        </ListItem>
        </Link>
        
        <Divider
          color="white"
          width="100%"
        />

        <Link  to='/collaborators' style={{textDecoration: 'none', color:'white'}} onClick={toggle}>
        <ListItem disablePadding>
          <ListItemButton>
            <ListItemText className={classes.text}>{language === 'eng' ? "COLLABORATORS" : "COLLABORATEUR"} </ListItemText>
          </ListItemButton>
        </ListItem>
        </Link>
        
        <Divider
          color="white"
          width="100%"
        />

        <Link  to='/collections' style={{textDecoration: 'none', color:'white'}} onClick={toggle}>
        <ListItem disablePadding>
          <ListItemButton>
            <ListItemText className={classes.text}>{language === 'eng' ? "COLLECTIONS" : "COLLECTION"} </ListItemText>
          </ListItemButton>
        </ListItem>
        </Link>


        <Divider
          color="white"
          width="100%"
        />

<ListItem disablePadding>
              <div className={classes.categoriesmob}>
                  <h2
                    onClick={() => setcatisopen(!catopen)}
                    style={
                      catopen
                        ? {
                            display: "grid",
                            gridTemplateColumns: "80% 20%",
                            paddingLeft: "2%",
                            background:'var'
                          }
                        : {
                            display: "grid",
                            gridTemplateColumns: "80% 20%",
                            borderBottom: "none",
                            paddingLeft: "2%",
                          }
                    }
                  >
                    {language === "eng" ? "THE CATEGORIES" : "LES CATEGORIES"}{" "}
                    {catopen ? (
                      <span
                        style={{
                          margin: "auto",
                          paddingRight: "0",
                          rotate: "180deg",
                        }}
                      >
                        <IoIosArrowDown />
                      </span>
                    ) : (
                      <span style={{ margin: "auto", paddingLeft: "0" }}>
                        <IoIosArrowDown />
                      </span>
                    )}
                  </h2>
                  {catopen && (
                    <div
                      className={classes.dropdown}
                      style={{ height: "250px", overflowY: "scroll" }}
                    >
                      {mappedParents.map((parent, index) => (
                        <TreeNode key={index} data={parent} level={0} />
                      ))}
                    </div>
                  )}
                </div>
        </ListItem>


                <Divider
          color="white"
          width="100%"
        />


        <Link  to='/about-us' style={{textDecoration: 'none', color:'white'}} onClick={toggle}>
        <ListItem disablePadding>
          <ListItemButton>
            <ListItemText className={classes.text}>{language === 'eng' ? "ABOUT US" : "À PROPOS"} </ListItemText>
          </ListItemButton>
        </ListItem>
        </Link>


        <Divider
          color="white"
          width="100%"
        />


        <Link  to='/events' style={{textDecoration: 'none', color:'white'}} onClick={toggle}>
        <ListItem disablePadding>
          <ListItemButton>
            <ListItemText className={classes.text}>
            {language === 'eng' ? "EVENTS" : "EVENEMENT"} 
            </ListItemText>
          </ListItemButton>
        </ListItem>
        </Link>


        <Divider
          color="white"
          width="100%"
        />


        <Link  to='/contactus' style={{textDecoration: 'none', color:'white'}} onClick={toggle}>
        <ListItem disablePadding>
          <ListItemButton>
            <ListItemText className={classes.text}>
            CONTACT
            </ListItemText>
          </ListItemButton>
        </ListItem>
        </Link>

        <Divider
          color="white"
          width="100%"
        />


        <Link  to='/legal-information' style={{textDecoration: 'none', color:'white'}} onClick={toggle}>
        <ListItem disablePadding>
          <ListItemButton>
            <ListItemText className={classes.text}>
            {language === "eng" ? "LEGAL INFORMATION" : "MENTIONS LEGALES"}
            </ListItemText>
          </ListItemButton>
        </ListItem>
        </Link>


        <Divider
          color="white"
          width="100%"
        />

<ListItem disablePadding>
                <div className={classes.categoriesmob}>
                    <h2
                      onClick={() => setLangisopen(!langopen)}
                      style={
                        langopen
                          ? {
                              display: "grid",
                              gridTemplateColumns: "80% 20%",
                              paddingLeft: "2%",
                              background:'var',
                              textTransform:"uppercase"
                            }
                          : {
                              display: "grid",
                              gridTemplateColumns: "80% 20%",
                              borderBottom: "none",
                              paddingLeft: "2%",
                              textTransform:"uppercase"
                            }
                      }
                    >
                      {language === "eng" ? "LANGUAGE" : "LANGUE"} ({language})
                      {langopen ? (
                        <span
                          style={{
                            margin: "auto",
                            paddingRight: "0",
                            rotate: "180deg",
                          }}
                        >
                          <IoIosArrowDown />
                        </span>
                      ) : (
                        <span style={{ margin: "auto", paddingLeft: "0" }}>
                          <IoIosArrowDown />
                        </span>
                      )}
                    </h2>
                    {langopen && (
                      <div
                        className={classes.dropdown}
                      >
                          <p onClick={async () => {
                              const lan = 'eng';
                                dispatch(changeLanguage({ Language: lan }));
                              try {
                                await axios.put(
                                  `${process.env.REACT_APP_TESTING_API}/users/${user.id}`,
                                  { 'language':lan },
                                  {
                                    headers: {
                                      Authorization: `Bearer ${token}`,
                                    },
                                  }
                                );
                              } catch (error) {
                                // console.error("Error updating language:", error);
                              }
                              toggle();
                            }} className={classes.text} style={{margin:"0.5em 0 .5em 2.5em",textTransform:"uppercase", background: language === "eng" ? "var(--secondary-color)" : ''}}> ENGLISH</p>
                          <p onClick={async () => {
                              const lan = 'fr';
                                dispatch(changeLanguage({ Language: lan }));
                              try {
                                await axios.put(
                                  `${process.env.REACT_APP_TESTING_API}/users/${user.id}`,
                                  { 'language':lan },
                                  {
                                    headers: {
                                      Authorization: `Bearer ${token}`,
                                    },
                                  }
                                );
                              } catch (error) {
                                // console.error("Error updating language:", error);
                              }
                              toggle();
                            }} className={classes.text} style={{margin:"0 0 .5em 2.5em",textTransform:"uppercase", background: language === "fr" ? "var(--secondary-color)" : ''}}>Français</p>
                      </div>
                    )}
                  </div>
          </ListItem>
        <Divider
          color="white"
          width="100%"
        />
        
        <ListItem disablePadding>
                <div className={classes.categoriesmob}>
                    <h2
                      onClick={() => setcurrenisopen(!currenopen)}
                      style={
                        currenopen
                          ? {
                              display: "grid",
                              gridTemplateColumns: "80% 20%",
                              paddingLeft: "2%",
                              background:'var',
                              textTransform:"uppercase"
                            }
                          : {
                              display: "grid",
                              gridTemplateColumns: "80% 20%",
                              borderBottom: "none",
                              paddingLeft: "2%",
                              textTransform:"uppercase"
                            }
                      }
                    >
                      {language === "eng" ? "CURRENCY" : "DEVISE"}{" "}({currency})
                      {currenopen ? (
                        <span
                          style={{
                            margin: "auto",
                            paddingRight: "0",
                            rotate: "180deg",
                          }}
                        >
                          <IoIosArrowDown />
                        </span>
                      ) : (
                        <span style={{ margin: "auto", paddingLeft: "0" }}>
                          <IoIosArrowDown />
                        </span>
                      )}
                    </h2>
                    {currenopen && (
                      <div
                        className={classes.dropdown}
                      >
                          <p onClick={async (event) => {
                                  const cur = "usd";
                                    dispatch(changeCurrency({ currency: cur }));
                                  try {
                                    await axios.put(
                                      `${process.env.REACT_APP_TESTING_API}/users/${user.id}`,
                                      { 'currency':cur },
                                      {
                                        headers: {
                                          Authorization: `Bearer ${token}`,
                                        },
                                      }
                                    );
                                  } catch (error) {
                                    // console.error("Error updating currency:", error);
                                  }
                                  toggle();
                                  setcurrenisopen(false);
                                }} className={classes.text} style={{margin:"0.5em 0 .5em 2.5em",textTransform:"uppercase", background: currency === "usd" ? "var(--secondary-color)" : ''}}> Dollar</p>
                          <p onClick={async (event) => {
                              const cur = "eur";
                                dispatch(changeCurrency({ currency: cur }));
                              try {
                                await axios.put(
                                  `${process.env.REACT_APP_TESTING_API}/users/${user.id}`,
                                  { 'currency':cur },
                                  {
                                    headers: {
                                      Authorization: `Bearer ${token}`,
                                    },
                                  }
                                );
                              } catch (error) {
                                // console.error("Error updating currency:", error);
                              };
                              toggle();
                              setcurrenisopen(false);
                            }} className={classes.text} style={{margin:"0 0 .5em 2.5em",textTransform:"uppercase", background: currency === "eur" ? "var(--secondary-color)" : ''}}>Euro</p>
                      </div>
                    )}
                  </div>
          </ListItem>
        <Divider
          color="white"
          width="100%"
        />
      </List>
    </Box>
    </>
  );

  return (
    <div>
      {["left"].map((anchor) => (
        <React.Fragment key={anchor} >
          <Drawer 
          anchor={anchor} 
          open={isOpen} 
          onClose={toggle}  
          PaperProps={{
        style: {
          height: '100%',
          // margin:'10em 0',
          width: '100%',
          background:'transparent',
          alignSelf:'start' // You can adjust the width as needed
        },
      }}>
            {list(anchor)}
          </Drawer>
        </React.Fragment>
      ))}
    </div>
  );
}
